import React from 'react';
import { get } from 'lodash/fp';
import PropTypes from 'prop-types';
import { Icon, Table } from 'rsuite';
import styled from 'styled-components';
import { UserType } from '../../../../../interfaces/portal';

const StyledIcon = styled(Icon)`
  top: 5px;
  left: 0px;
  position: absolute;
`;

const VerifiedCell = ({ dataKey, rowData, ...props }) => (
  <Table.Cell {...props}>
    {get('verifiedAt', rowData) ? (
      <StyledIcon icon="check-circle" style={{ color: '#4caf50' }} />
    ) : (
      <StyledIcon
        icon="exclamation-circle"
        style={{ fontSize: 16, color: 'orange' }}
      />
    )}
    {get('email', rowData)}
  </Table.Cell>
);

VerifiedCell.propTypes = {
  dataKey: PropTypes.string.isRequired,
  rowData: UserType
};

VerifiedCell.defaultProps = {
  rowData: null
};

export default VerifiedCell;
